module.exports = __webpack_public_path__ + "img/two1.d7d1673a.png";